// components/ObjectNameCell.js
import {memo} from "react";

export const ObjectNameCell = memo(({text, balance}) => {
    const isNegative = (balance || 0) < 0;

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            position: 'relative'
        }}>
            {isNegative && (
                <div style={{
                    position: 'absolute',
                    left: '-12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '3px',
                    height: '20px',
                    backgroundColor: '#cf1322',
                    borderRadius: '2px'
                }}/>
            )}
            <span style={{
                fontSize: '14px',
                fontWeight: 500,
                color: '#262626'
            }}>
                {text}
            </span>
        </div>
    );
});

ObjectNameCell.displayName = 'ObjectNameCell';